module.exports = __webpack_public_path__ + "dist/img/user-patient.6c53ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-patient.png
// module id = 8YSq
// module chunks = 1